// src/TableOfContents.js
import { useEffect, useState } from "react";

export default function TableOfContents({ headings }) {
    const [activeId, setActiveId] = useState("");

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActiveId(entry.target.id);
                    }
                });
            },
            { rootMargin: "-20% 0px -35% 0px" }
        );

        headings.forEach(({ id }) => {
            const element = document.getElementById(id);
            if (element) observer.observe(element);
        });

        return () => observer.disconnect();
    }, [headings]);

    if (headings.length === 0) return null;

    return (
        <nav className="toc">
            <h4 className="toc-title">Contents</h4>
            <ul>
                {headings.map(({ level, text, id }) => (
                    <li key={id} className={`toc-item toc-level-${level}`}>
                        <a href={`#${id}`} className={activeId === id ? "active" : ""} onClick={(e) => {
                            e.preventDefault();
                            document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
                        }}>
                            {text}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    );
}